/**
 * Phonebay scroll reveal — header on load, sections on scroll
 */
(function () {
  function init() {
    const header = document.querySelector('.header-wrapper');
    if (header) {
      header.classList.add('pb-reveal', 'pb-reveal--header');
      requestAnimationFrame(() => {
        header.classList.add('pb-reveal--is-visible');
      });
    }

    const targets = document.querySelectorAll('.pb-reveal-on-scroll');
    if (!targets.length) return;

    if (!('IntersectionObserver' in window)) {
      targets.forEach((el) => el.classList.add('pb-reveal--is-visible'));
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('pb-reveal--is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px -48px 0px' }
    );

    targets.forEach((el) => observer.observe(el));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
